import { Controller } from "@hotwired/stimulus";
import { sanitizeCreditCard } from "../sanitizers";

/**
 * Sanitizes credit card numbers from input fields.
 *
 * NOTE: There is a server-side equivalent in app/models/concerns/sanitize_credit_card_numbers.rb.
 * If you change the sanitization logic here, update it there too.
 *
 * Usage (directly on input/textarea):
 *   <textarea data-controller="credit-card-sanitizer"
 *             data-action="focusout->credit-card-sanitizer#sanitize"></textarea>
 *
 * Or wrapping a field:
 *   <div data-controller="credit-card-sanitizer">
 *     <input data-action="focusout->credit-card-sanitizer#sanitize" name="first_name" />
 *     <textarea data-action="focusout->credit-card-sanitizer#sanitize" name="comments"></textarea>
 *   </div>
 */
export default class extends Controller {
  sanitize(event) {
    const element = event.target;
    const originalValue = element.value;
    const sanitizedValue = sanitizeCreditCard(originalValue);

    if (sanitizedValue !== originalValue) {
      element.value = sanitizedValue;
      element.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }
}
